export default __webpack_public_path__ + "static/media/dashboard_heathinfo_img.b907c334.svg";